import {Pipe, PipeTransform} from '@angular/core';
import {DayOfWeek} from './datamodel/class-group';
import {environment} from '../environments/environment';

@Pipe({
  name: 'dayOfWeek'
})
export class DayOfWeekPipe implements PipeTransform {

  transform(value: DayOfWeek, ...args: any[]): any {
    if (environment.lang === 'en') {
      return value;
    }
    switch (value) {
      case DayOfWeek.Monday:
        return 'poniedziałek';
      case DayOfWeek.Tuesday:
        return 'wtorek';
      case DayOfWeek.Wednesday:
        return 'środa';
      case DayOfWeek.Thursday:
        return 'czwartek';
      case DayOfWeek.Friday:
        return 'piątek';
      case DayOfWeek.Saturday:
        return 'sobota';
      case DayOfWeek.Sunday:
        return 'niedziela';
    }
  }
}
